import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { useItem } from './hook';
import { contextConnect } from '../../ui/context';
import { View } from '../../view';

function Item(props, forwardedRef) {
  const {
    role,
    wrapperClassName,
    ...otherProps
  } = useItem(props);
  return createElement("div", {
    role: role,
    className: wrapperClassName
  }, createElement(View, _extends({}, otherProps, {
    ref: forwardedRef
  })));
}

export default contextConnect(Item, 'Item');
//# sourceMappingURL=component.js.map